import $ from "jquery";
import Vue from "vue";
import * as ers from "../../../errorsmessages/errors";
import * as suc from "../../../successmessages/success";
import * as rt from "../../../routes/routes";
import * as ses from "../../../configurations/session/sessioncomplete";
import baseurl from "../../../configurations/baseurl/baseurl";
import router from "../../../router/index";

export const actions = {
  newFile() {
    let fileopeningDetails = {
      customer_id: $(".customer_id").val(),
      file_ref: $(".file_ref").val(),
      received_date: $(".received_date").val(),
      opened_date: $(".opened_date").val(),
      file_code: $(".file_code").val(),
      file_mov: $(".file_mov").val(),
      bill_landing: $(".bill_landing").val(),
      file_route: $(".file_route").val(),
      shipping_id: $(".shipping_id").val(),
      clearing_agent: $(".clearing_agent").val(),
      cargo_status: $(".cargo_status").val(),
      origin: $(".origin").val(),
      destination: $(".destination").val(),
      eta: $(".eta").val(),
      discharge_port: $(".discharge_port").val(),
      vessel: $(".vessel").val(),
      description: $(".description").val(),
      cargo_qty: $(".cargo_qty").val(),
      remarks: $(".remarks").val()
    };
    console.log(fileopeningDetails);

    $(".creatingFileopening").hide();
    $(".creatingFileopeningLoader").show();
    baseurl.post(rt.newFiles, fileopeningDetails).then(res => {
      $(".creatingFileopening").show();
      $(".creatingFileopeningLoader").hide();

      //checking responses codes from backend api

      if (res.data.code === 200) {
        //success codes
        suc.fileCreateSuccess();
        router.push("/managefileopenings");
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 403) {
        //files exits
        ers.FileopeningExists();
      } else if (res.data.code === 404) {
        //error on creating file
        ers.errorCreatingFileopening();
      } else if (res.data.code === 405) {
        //no permission to create file
        ers.noPermissionToCreate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session complete
        ses.sessionComplete();
      }
    });
  },

  //getting all files
  loadFileopenings({ commit }) {
    baseurl.get(rt.loadFileopening).then(res => {
      $(".fileopeningsLoader").hide();
      //checking responses codes from backend api

      if (res.data.code === 200) {
        //success code
        commit("STORE_FILEOPENINGS", res.data.files);
      } else if (res.data.code === 404) {
        //error on loading files data
        ers.errorLoadingFileopening();
      } else if (res.data.code === 405) {
        commit("STORE_FILEOPENINGS", []);
        //no permission to read
        ers.noPermissionToRead();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired
        ses.sessionComplete();
      }
    });
  },

  loadFileopening({ commit }) {
    baseurl.get(rt.loadFile).then(res => {
      //checking responses codes from backend api

      commit("STORE_FILES", res.data.file_no);
    });
  },

  viewFileopening({ commit }, fileopeningId) {
    commit("STORE_FILEOPENING_UPDATE", fileopeningId);
    router.push("/updatefileopening");
  },

  viewFileopeninginvoice({ commit }, fileopeningId) {
    commit("STORE_FILEOPENING_UPDATE", fileopeningId);
    router.push("/newinvoice");
  },

  fileCargo({ commit }, fileopeningId) {
    commit("STORE_FILEOPENING_UPDATE", fileopeningId);
    router.push("/newcargoentry");
  },
  fileopeningUpdate({ commit }) {
    let fileopeningDetails = {
      id: $(".id").val(),
      customer_id: $(".customer_id").val(),
      received_date: $(".received_date").val(),
      opened_date: $(".opened_date").val(),
      file_code: $(".file_code").val(),
      file_mov: $(".file_mov").val(),
      bill_landing: $(".bill_landing").val(),
      file_route: $(".file_route").val(),
      shipping_id: $(".shipping_id").val(),
      clearing_agent: $(".clearing_agent").val(),
      cargo_status: $(".cargo_status").val(),
      origin: $(".origin").val(),
      destination: $(".destination").val(),
      eta: $(".eta").val(),
      discharge_port: $(".discharge_port").val(),
      vessel: $(".vessel").val(),
      description: $(".description").val(),
      cargo_qty: $(".cargo_qty").val(),
      remarks: $(".remarks").val()
    };
    console.log(fileopeningDetails);

    $(".updatingFileopening").hide();
    $(".updatingFileopeningLoader").show();
    baseurl.post(rt.updateFileOpening, fileopeningDetails).then(res => {
      $(".updatingFileopening").show();
      $(".updatingFileopeningLoader").hide();

      //checking responses code from backend api

      if (res.data.code === 200) {
        suc.fileUpdateSuccess();
        commit("STORE_FILEOPENINGS", res.data.files);
        setTimeout(() => {
          router.push("/managefileopenings");
        }, 3000);
      } else if (res.data.code === 402) {
        //validation code
        ers.validateErrors();
      } else if (res.data.code === 404) {
        //error on updating records
        ers.errorUpdatingFileopening();
      } else if (res.data.code === 405) {
        //no permission to update
        ers.noPermissionToUpdate();
        router.push("/dashboard");
      } else if (res.data.code === 506) {
        //session expired code
        ses.sessionComplete();
      }
    });
  },

  getSequence() {
    // Get Year portion
    var now = new Date(); //current date
    var fullYear = now.getFullYear().toString(); //current 4-digit year
    var year = fullYear.substring(2, 4);

    // Get sequence # from hidden field
    var seq = 1;
    var paddedSeq = "0000" + seq;
    var paddedSeq = paddedSeq.substring(paddedSeq.length - 4, paddedSeq.length);
    var output = year + "-" + paddedSeq;
    return output;
  }
};
export default actions;



// WEBPACK FOOTER //
// ./src/vuex/modules/fileopenings/actions.js